import React from 'react'
import { GridCell } from '@progress/kendo-react-grid'
import { Button } from '@/components/button'
import { openDialog } from '@/store/Dialogs'
import { getStore } from '@/store'
import { dialogTypes } from '@/dialogs'
import { localized } from '@/decorators/localized'

@localized()
class StepErrorCell extends GridCell {
  render () {
    const { dataItem, field } = this.props
    const value = dataItem[field]
    const errors = dataItem['errors']
    if (value > 0 && errors && errors.length > 0) {
      return <td><Button color='danger' onClick={() => getStore().dispatch(openDialog({
        dialogType: dialogTypes.alert,
        title: 'Tickets.StepErrors',
        localizedContent: errors.map(x => this.props.localize(x)).join(' '),
        errors: errors
      }))}>{value}</Button></td>
    }
    return (<td>{value}</td>)
  }
}

export default StepErrorCell



// WEBPACK FOOTER //
// ./src/internal-app/pages/tickets/stepErrorCell.js